import { SESSION_APPOINTMENT_TYPES } from '../hooks/api/config';


  // Función helper para obtener el nombre del servicio desde appointment_type
  export const getServiceNameFromAppointmentType = (appointmentTypeId: string | null | undefined): string => {
    if (!appointmentTypeId) return 'Sin tipo';
    
    // Buscar el appointment_type en SESSION_APPOINTMENT_TYPES
    const appointmentType = SESSION_APPOINTMENT_TYPES.find(type => type.id === appointmentTypeId);
    if (!appointmentType) return appointmentTypeId; // Si no se encuentra, devolver el ID
    
    // El name en SESSION_APPOINTMENT_TYPES es el nombre del servicio clínico
    return appointmentType.name;
  };

export enum PsychologistFreeScheduleStatus {
  AVAILABLE = 'recVxSGmaZmZwh4vp',
	OCCUPIED_BY_SESSION = 'recUzrq3RPBGOO8u9',
	OCCUPIED_BY_VACATION = 'rec0kR9XnNtR4cXvD',
	OCCUPIED_MANUAL_BY_PSYCHOLOGIST = 'recmOous2cuUpgFG4',
	RESCHEDULED = 'recMio3tO0hRAIQyR',
	CANCELLED = 'recVnbOGwlU30I1qr',
	EXPIRED = 'recsqW4LcpnnR0bch',
}

export interface Slot {
  id: string;
  psychologist: string;
  slot: string;
  created_at: string;
  updated_at?: string;
  deleted_at?: string | null;
  appointment_type?: string | null;
  process_recurrence_id?: string | null;
  status: PsychologistFreeScheduleStatus;
  reason: string | null;
  schedule_type?: string | null;
}


